import { MetaListItem } from "../../pages/Layouts/components/MetaList";
import {
  BuildOutlined,
  CancelOutlined,
  DeleteForeverOutlined,
  ErrorOutlineOutlined,
  QuestionMarkOutlined,
  RequestQuoteOutlined,
  SellOutlined,
  VisibilityOutlined,
} from "@mui/icons-material";
import React from "react";

export function InventoryStateMetaListItem({ state }: { state?: string }) {
  switch (state) {
    case "in_process":
      return <MetaListItem label="In Process" title={`State: ${state}`} icon={<BuildOutlined />} />;
    case "resellable":
      return <MetaListItem label="Resellable" title={`State: ${state}`} icon={<SellOutlined />} />;
    case "invoiced":
      return <MetaListItem label="Invoiced" title={`State: ${state}`} icon={<RequestQuoteOutlined />} />;
    case "ewasted":
      return <MetaListItem label="e-Wasted" title={`State: ${state}`} icon={<DeleteForeverOutlined />} />;
    case "deleted":
      return <MetaListItem label="Deleted" title={`State: ${state}`} icon={<CancelOutlined />} />;
    case "missing":
      return <MetaListItem label="Missing" title={`State: ${state}`} icon={<QuestionMarkOutlined />} />;
    case "pending_review":
      return <MetaListItem label="Pending Review" title={`State: ${state}`} icon={<VisibilityOutlined />} />;
    default:
      return <MetaListItem label="Unknown" title={`State: ${state}`} icon={<ErrorOutlineOutlined />} />;
  }
}
